import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export const AfterPageRendered = ({ onDone }) => {
  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      onDone(location);
    });
  }, [location, onDone]);

  return null;
};
